import React from 'react';

const ProgressRectangle = ({progress}: any) => {
    const bluerRectangleStyle = {
        width: `${progress}px`,
        height: '5px',
        backgroundColor: 'var(--logo-color-blue)',
        borderRadius: '5px'
    };

    const  whiterRectangleStyle= {
        width: '90px',
        height: '5px',
        backgroundColor: '#FFFFFF',
        borderRadius: '5px'
    };

    return(
        <div style={whiterRectangleStyle}>
            <div style={bluerRectangleStyle}/>
        </div>
    );
};

export default ProgressRectangle;